import { render, staticRenderFns } from "./ServiceDetailsDialog.vue?vue&type=template&id=4dbb98fb&scoped=true&"
import script from "./ServiceDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb98fb",
  null
  
)

export default component.exports